// import { api } from "@/plugins/api";

const state = {
  questions: [],
};

const getters = {
  getQuestions: (state) => state.questions,
};

const actions = {
  async setQuestions({ commit }, data) {
    commit("setQuestions", data);
  },
};

const mutations = {
  setQuestions(state, data) {
    state.questions = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
